import { supabase } from "./supabase";

/* WHO IS SIGNED IN — for a read that means "MY rows" (2026-09-23).
 *
 * 🔴 A NEW READ POLICY WIDENS EVERY EXISTING READER OF ITS TABLE, SILENTLY (codex,
 * live-database-discipline). `coach_exercises` and `coach_workouts` (templates included) let an
 * ACTIVE, ACCEPTED client read their coach's rows, so a library screen that relied on RLS alone
 * would hand a coach who is also somebody's CLIENT that other coach's library — to edit, duplicate,
 * assign and delete. Every library list therefore names its owner: `.eq("coach_id", await myId())`.
 *
 * Signed out → the empty string, which matches no row (a uuid column refuses it, and the screen's
 * own error path says so) — never "every row RLS happens to admit". */
export async function myId(): Promise<string> {
  const { data } = await supabase.auth.getSession();
  return data.session?.user.id ?? "";
}
